import { Injectable } from '@angular/core';
import { UserPickupShopsFacade } from '@checkout/data-access';

@Injectable({
  providedIn: 'root',
})
export class UserPickupShopsService {
  list$ = this.userPickupShopsFacade.getList();
  listState$ = this.userPickupShopsFacade.getListState();
  listLoading$ = this.userPickupShopsFacade.getListLoading();
  listSuccess$ = this.userPickupShopsFacade.getListSuccess();
  listError$ = this.userPickupShopsFacade.getListError();

  constructor(private userPickupShopsFacade: UserPickupShopsFacade) {}

  add(shopName: string): void {
    this.userPickupShopsFacade.add(shopName);
  }

  remove(shopName: string): void {
    this.userPickupShopsFacade.remove(shopName);
  }
}
